import { CarIcon, TransitIcon, WalkingIcon } from '@/assets/icons'
import React from 'react'

export interface TransportModeIconProps {
	/** A route's `transportMode` ("TRANSIT", "WALKING", …); anything else reads as driving. */
	mode: string
	/** An `iconSizes` step; left out, the glyph takes its size from the chip around it. */
	size?: number
}

/** The glyph for a travel segment's mode — one mapping for the day pane's travel row, the public board and the overview tile. */
const TransportModeIcon: React.FC<TransportModeIconProps> = ({ mode, size }) => {
	const sx = size === undefined ? undefined : { fontSize: size }
	switch (mode) {
		case 'TRANSIT':
			return <TransitIcon sx={sx} />
		case 'WALKING':
			return <WalkingIcon sx={sx} />
		default:
			return <CarIcon sx={sx} />
	}
}

export default TransportModeIcon
